import { render, staticRenderFns } from "./CJ9100Component.vue?vue&type=template&id=7b20995a&scoped=true&"
import script from "./CJ9100Component.vue?vue&type=script&lang=js&"
export * from "./CJ9100Component.vue?vue&type=script&lang=js&"
import style0 from "./CJ9100Component.vue?vue&type=style&index=0&id=7b20995a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b20995a",
  null
  
)

export default component.exports